import { addModal } from 'weblite-web-modal-viewer'
import { InviteLinkDetailsModal } from './invite-link-details-modal'

const COMPONENT_ID = 'inviteLinkModal'

export const showInviteLinkModal = (
  props: Parameters<typeof InviteLinkDetailsModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: InviteLinkDetailsModal,
  },
}
